import DefaultDetail from "@Common/DefaultDetail";
// import { toJS } from "mobx";
import { inject, observer } from "mobx-react";

import { useParams } from "react-router-dom";

import "./style.scss";
import { getEditInputsByStep } from "../../config.jsx";

const EditReal = inject("mainStore")(
    observer(({ mainStore }) => {
        const detailData = mainStore.getMainStore("detailData");
        const { secondParam } = useParams();

        const inputsByStep = getEditInputsByStep({ mainStore, detailData });
        const stepsOrder = ["step1", "step2", "step3", "step4", "step5", "step6"];
        const inputsNew = stepsOrder.reduce((acc, key) => acc.concat(inputsByStep[key] || []), []);

        return <DefaultDetail apiUrl={secondParam === "add" ? "/promo/offers" : `/promo/offers/${secondParam}`} dataKey={secondParam} inputs={inputsNew} page={"offers"} backEnabled={false} title="оффер" />;
    }),
);

export default EditReal;
